import { createRouter, createWebHistory } from 'vue-router';

import { routerPaths } from '@/router/router-path';

import { globalNavigationGuard } from './guards';

const Login = () => import('@/views/login/Login.vue');
const NotFound = () => import('@/views/404.vue');
const NotAllowed = () => import('@/views/403.vue');

const router = createRouter({
  history: createWebHistory(''),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      meta: {
        isCustomerAllowed: true,
      },
    },
    {
      //** page not found */
      path: `${routerPaths[404]}`,
      name: '404',
      component: NotFound,
      meta: {
        isCustomerAllowed: true,
      },
    },
    {
      //** page not found */
      path: `${routerPaths[403]}`,
      name: '403',
      component: NotAllowed,
      meta: {
        isCustomerAllowed: true,
      },
    },
    {
      path: '/entralogin',
      name: 'entralogin',
      component: Login,
      props: true,
      meta: {
        fullscreen: true,
        layout: 'BlankLayout',
      },
    },
    {
      path: '/:chunk1/:chunk2/:chunk3/:chunk4/:chunk5',
      name: 'DynamicSubcomponentDetailActionRoute',
      component: {
        template: '<div></div>',
      },
      meta: { dynamicRoute: true },
    },
    {
      path: '/:chunk1/:chunk2/:chunk3/:chunk4',
      name: 'DynamicSubcomponentDetailRoute',
      component: {
        template: '<div></div>',
      },
      meta: { dynamicRoute: true },
    },
    {
      path: '/:chunk1/:chunk2/:chunk3',
      name: 'DynamicComponentActionOrSubcomponentRoute',
      component: {
        template: '<div></div>',
      },
      meta: { dynamicRoute: true },
    },
    {
      path: '/:chunk1/:chunk2',
      name: 'DynamicComponentDetailRoute',
      component: {
        template: '<div></div>',
      },
      meta: { dynamicRoute: true },
    },
    {
      path: '/:chunk1',
      name: 'DynamicComponentRoute',
      component: {
        template: '<div></div>',
      },
      meta: { dynamicRoute: true },
    },

    {
      //** page not found */
      path: '/:catchAll(.*)',
      name: 'NotFound',
      component: NotFound,
    },
  ],
});

// Use the global navigation guard
router.beforeEach(globalNavigationGuard);

export default router;
